// Topic-specific Unsplash photo pools — each entry deterministically picks one
// based on slug hash so the same slug always shows the same image, but consecutive entries differ.
// All photo IDs are verified stable Unsplash assets.

const POOLS = {
  // Cricket action / stadium
  cricket: [
    'photo-1531415074968-036ba1b575da', // cricket batting silhouette
    'photo-1540747913346-19e32dc3e97e', // cricket bat & ball wood
    'photo-1593766787879-bf1cf2ee6624', // stadium lights night
    'photo-1602674809970-50e0f02697a8', // floodlit ground
    'photo-1624280157150-4d1ed8632989', // cricket pitch closeup
    'photo-1571019613454-1cb2f99b2d8b', // stadium crowd
    'photo-1588767283519-83f1f4e5e51f', // cricket helmet
    'photo-1518895949257-7621c3c786d7', // cricket field aerial
  ],
  // Cricket player portraits / poses (Unsplash sports portraits)
  cricketer: [
    'photo-1605833556407-fe72c2c0250b', // bowler delivery action
    'photo-1531415074968-036ba1b575da', // batting silhouette
    'photo-1599058917765-a780eda07a3e', // pitch action
    'photo-1574629810360-7efbbe195018', // catch celebration
    'photo-1571019613454-1cb2f99b2d8b', // crowd / dugout
    'photo-1599901860904-17e6ed7083a0', // close-up sporting gear
    'photo-1606925797300-0b35e9d1794e', // batter on field
    'photo-1607923432735-a47de36c7afa', // bowling
  ],
  // Soccer / football
  soccer: [
    'photo-1486286701208-1d58e9338013', // soccer player kicking
    'photo-1574629810360-7efbbe195018', // stadium night
    'photo-1551958219-acbc608c6377', // ball mid-air
    'photo-1579952363873-27f3bade9f55', // grass and ball
    'photo-1606925797300-0b35e9d1794e', // stadium
    'photo-1574629810360-7efbbe195018', // crowd celebration
    'photo-1518604666860-9ed391f76460', // goal net
    'photo-1431324155629-1a6deb1dec8d', // boots
  ],
  // Gaming / esports
  gaming: [
    'photo-1542751371-adc38448a05e',   // gaming controller setup
    'photo-1493711662062-fa541adb3fc8', // RGB gaming
    'photo-1538485399081-7c8978a30c12', // gaming keyboard
    'photo-1551103782-8ab07afd45c1',   // playing video games
    'photo-1606326608690-4e0281b1e588', // neon arcade
    'photo-1614680376593-902f74cf0d41', // phone gaming
    'photo-1511512578047-dfb367046420', // mobile gaming
    'photo-1623934199716-dc28818a307a', // racing console
  ],
  // PC hardware / setup
  pc: [
    'photo-1587202372616-b43abea06c2a', // gaming PC RGB
    'photo-1591488320449-011701bb6704', // CPU close
    'photo-1518770660439-4636190af475', // circuit board
    'photo-1555680202-c86f0e12f086',   // hardware
    'photo-1593640408182-31c70c8268f5', // gaming monitor
    'photo-1587829741301-dc798b83add3', // keyboard
    'photo-1599669454699-248893623440', // headset
    'photo-1597872200969-2b65d56bd16b', // ssd
  ],
  // OTT / streaming / TV
  ott: [
    'photo-1593359677879-a4bb92f829d1', // TV remote
    'photo-1522869635100-9f4c5e86aa37', // streaming setup
    'photo-1611162616305-c69b3fa7fbe0', // streaming binge
    'photo-1574375927938-d5a98e8ffe85', // netflix-style
    'photo-1626814026160-2237a95fc5a0', // home theatre
    'photo-1517604931442-7e0c8ed2963c', // popcorn cinema
  ],
  // Anime / manga
  anime: [
    'photo-1607604276583-eef5d076aa5f', // anime figures
    'photo-1618519764620-7403abdbdfe9', // colorful figures
    'photo-1612036782180-6f0822045d23', // collectibles
    'photo-1611605698335-8b1569810432', // manga reading
    'photo-1626808642875-0aa545482dfb', // tokyo neon
    'photo-1607604276625-e89bcb83d8c4', // anime art
  ],
  // Movies / franchise
  franchise: [
    'photo-1635805737707-575885ab0820', // marvel theme
    'photo-1485846234645-a62644f84728', // cinema
    'photo-1604079628040-94301bb21b91', // film reel
    'photo-1626814026160-2237a95fc5a0', // tv setup
    'photo-1542204165-65bf26472b9b',   // popcorn night
    'photo-1517604931442-7e0c8ed2963c', // cinema seats
  ],
  // Tournaments / esports stages
  tournament: [
    'photo-1493711662062-fa541adb3fc8', // esports stage
    'photo-1542751371-adc38448a05e',   // crowd
    'photo-1551103782-8ab07afd45c1',   // arena
    'photo-1538481199705-c710c4e965fc', // celebration
    'photo-1542204165-65bf26472b9b',   // trophy stage
  ],
  // Fantasy / data
  fantasy: [
    'photo-1551434678-e076c223a692', // analytics
    'photo-1559526324-4b87b5e36e44', // sports data
    'photo-1551836022-aadb801c60ae', // fantasy app
    'photo-1556761175-5973dc0f32e7', // numbers
  ],
  // Generic fallback
  default: [
    'photo-1542751371-adc38448a05e',
    'photo-1551103782-8ab07afd45c1',
    'photo-1493711662062-fa541adb3fc8',
    'photo-1538485399081-7c8978a30c12',
  ],
};

function hashString(s) {
  let h = 0;
  if (!s) return 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Pick an image from the pool deterministically based on slug hash
export function topicImage(topic, slug, w = 720) {
  const pool = POOLS[topic] || POOLS.default;
  const id = pool[hashString(slug || topic) % pool.length];
  return `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;
}
